var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 30,
    viewBox: "0 0 16 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.07497 9.9373V21.268C5.08715 22.0966 5.40195 22.8867 5.95144 23.468C6.50094 24.0494 7.24106 24.3752 8.01209 24.3752C8.78313 24.3752 9.52325 24.0494 10.0727 23.468C10.6222 22.8867 10.937 22.0966 10.9492 21.268L10.9587 6.41639C10.9667 5.70822 10.8439 5.00538 10.5972 4.34862C10.3506 3.69186 9.98512 3.09425 9.52198 2.59043C9.05885 2.08661 8.50726 1.6866 7.89921 1.41359C7.29116 1.14058 6.63873 1 5.97974 1C5.32076 1 4.66833 1.14058 4.06027 1.41359C3.45222 1.6866 2.90063 2.08661 2.4375 2.59043C1.97436 3.09425 1.60888 3.69186 1.36225 4.34862C1.11562 5.00538 0.992738 5.70822 1.00073 6.41639V21.368C0.987308 22.3651 1.15843 23.355 1.50415 24.2803C1.84987 25.2056 2.36329 26.0478 3.01457 26.7579C3.66584 27.4681 4.44197 28.032 5.29784 28.4169C6.1537 28.8018 7.07222 29 8 29C8.92778 29 9.8463 28.8018 10.7022 28.4169C11.558 28.032 12.3342 27.4681 12.9854 26.7579C13.6367 26.0478 14.1501 25.2056 14.4958 24.2803C14.8416 23.355 15.0127 22.3651 14.9993 21.368V7.39626",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/fileUpload.a37596182ba2d70b5a2f83380215c492.svg";
export { ForwardRef as ReactComponent };